import React, { Component } from "react";
import "./Certifications.css";
import { Fade } from "react-reveal";
import { awards } from "../../portfolio";
import CertificationCarousel from "../../components/certificationCarousel/CertificationCarousel";

class Certifications extends Component {
  render() {
    const theme = this.props.theme;

    return (
      <div className="main" id="certs">
        <Fade bottom duration={1500} distance="50px">
          <CertificationCarousel certifications={awards.awards} theme={theme} />
        </Fade>
      </div>
    );
  }
}

export default Certifications;
